export interface WaitStateOverlayProps {
  illust?: string;
  headline: string;
  status?: string;
}

/** Primitive 11: Wait-state overlay (replaces bare spinners). */
export function WaitStateOverlay({
  illust = '⏳',
  headline,
  status,
}: WaitStateOverlayProps): JSX.Element {
  return (
    <div className="wait-overlay" role="status" aria-live="polite">
      <div className="wait-overlay__illust" aria-hidden>{illust}</div>
      <div className="wait-overlay__headline">{headline}</div>
      {status && <div className="wait-overlay__status">{status}</div>}
    </div>
  );
}
